const initialState = {
  customLayout: {},
};

function customLayout(state = initialState, action) {
  switch (action.type) {
    case 'RECEIVE_CUSTOM_LAYOUT':
      return {
        ...state,
        customLayout: action.customLayout,
      };
    default:
      return state;
  }
}

export default customLayout;
